<div class="t-content py-2" id="disney">
  <form (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="form-row pt-3 pb-3">
      <!--div class="form-group m-0 px-0 col-xg-3 col-lg-2 col-md-12 col-sm-12">
        <label for="atracciones">&nbsp;</label>
        <  formControlName='attraction' [items]="actividad" bindLabel="name" bindValue="id" placeholder="Select"
          class="custom">
        </>
      </div-->

      <div class="form-group col-xg-4 col-lg-3 col-md-12 col-sm-12">
        <div class="form-row">
          <div class="form-group col-xg-4 col-lg-6 col-md-12 col-sm-12 pr-0">

            <input formControlName="arrivalDate" type="text" class="form-control input-search-box btn-border-right" id="arrivalDate"
              placeholder="Check-in     -" autocomplete="off" bsDatepicker [minDate]="minDate" [bsConfig]="dpConfig"
              #dpArrival="bsDatepicker" (bsValueChange)="nextDate($event)" readonly>
            <span class="help-block text-danger"
              *ngIf="_form.get('arrivalDate').touched && _form.get('arrivalDate').hasError('required')">This field is
              required.</span>
            <small class="error-label"
              *ngIf="_form.get('arrivalDate').touched && _form.get('departureDate').value !== null && _form.get('arrivalDate').hasError('invalidDate')">
              * Check-in must be a date before Check-out!
            </small>
          </div>
          <div class="form-group col-xg-4 col-lg-6 col-md-12 col-sm-12 pl-0">
            <input formControlName="departureDate" type="text" class="form-control input-search-box btn-border-left" id="departureDate"
              placeholder="Check Out" autocomplete="off" bsDatepicker #dpDeparture="bsDatepicker" [minDate]="minDate"
              [bsConfig]="dpConfig" readonly>
            <span class="help-block text-danger"
              *ngIf="_form.get('departureDate').touched && _form.get('departureDate').hasError('required')">This field
              is required.</span>
            <small class="error-label"
              *ngIf="_form.get('departureDate').touched && _form.get('arrivalDate').value !== null && _form.get('departureDate').hasError('invalidDate')">
              * Check-out must be a date after Check-in!
            </small>

          </div>

        </div>
      </div>
      <div class="form-group col-xg-4 col-lg-4 col-md-12 col-sm-12 inp">
        <label for="roomandperson">&nbsp;</label>
        <button type="button" class="form-control btn-usb-rp" (click)="_openModal()" [attr.aria-expanded]="!isCollapsed"
          aria-controls="false">
          {{roomsAndPassengers}}
          <span class="arrow-sort fa fa-sort"></span>
        </button>
        <div *ngFor="let room of _form.value['room']; let i = index">
          <span class="help-block text-danger"
            *ngIf="((validate || (_close && isCollapsed)) && (room['qtyAdults'] == 0))">At least select 1 adult at room
            {{i+1}}.</span>
        </div>
        <div (click)="_over()" (collapsed)="clickOutside($event)" (expanded)="($event)"
          [collapse]="!isCollapsed || _close" class="justify-content-end">
          <div class="row p-0 m-0">
            <div class="col-xg-12 col-lg-12 col-md-12 col-sm-12 w-100">
              <div class="card">
                <div formArrayName="room" *ngFor="let item of formArray(_form, 'room'); let i = index"
                  class="d-flex flex-row col-12 align-items-center justify-content-between p-2">
                  <div [formGroupName]="i"
                    class="d-flex flex-row align-items-start justify-content-between col-12 p-0">
                    <div class="p-2 col-2" style="padding:25px 0 0 0 !important;">Room {{i + 1}}</div>
                    <div class="p-0 m-0 col-2">
                      <label for="adults">Adults</label>
                      <select formControlName="qtyAdults" class="custom-select form-control-sm " id="adults"
                        name="adults" [value]="0">
                        <option *ngFor="let qty of _maxPersons" [value]="qty">{{qty}}</option>
                      </select>
                    </div>
                    <div class="p-0 m-0 col-2">
                      <label for="childs">Children</label>
                      <select formControlName="qtyChilds" class="custom-select form-control-sm" id="childs"
                        (ngModelChange)="_addChild(item)" name="childs" [value]="0">
                        <option *ngFor="let qty of _maxPersons" [value]="qty">{{qty}}</option>
                      </select>
                    </div>
                    <div class="p-0 col-5">
                      <!-- Children age inputs -->
                      <div id="childrenAges" class="px-1 col-12" *ngIf="item.get('childsage').length > 0">
                        <label for="age">Edad niños</label>
                        <div class="d-flex flex-column p-0 m-0">
                          <div class="d-flex flex-r">
                            <div formArrayName="childsage"
                              *ngFor="let age of formArray(item, 'childsage'); let j = index;" class="col-3 select-ages">
                              <div [formGroupName]="j" class="col-12 p-0">
                                <input formControlName="age" min=0 max=17 limit-to="14"
                                  class="form-control col-11 p-3 input-age" value-formatter="0" placeholder="0"
                                  name="age">
                              </div>
                            </div>
                          </div>
                          <div *ngFor="let age of formArray(item, 'childsage'); let j = index;">
                            <span class="help-block text-danger d-flex w-100 text-nowrap"
                              *ngIf="age.controls['age'].hasError('invalidsoloNumeros') || age.controls['age'].hasError('min') || age.controls['age'].hasError('max') || age.controls['age'].hasError('required')"><br>Age
                              of children {{j+1}} is incorrect</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="p-0" style="margin-top: 27px;">
                      <button (click)="_removeRoom(i)" class="btn btn-outline-danger col-12 input-age btn-sm">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <hr>
                  </div>
                </div>
                <hr>
                <div class="d-flex justify-content-between flex-row">
                  <div class="p-2 justify-content-start">
                    <button type="button" (click)="_addRoom()" class="btn btn-outline-danger btn-sm">
                      Add Room
                    </button>
                  </div>
                  <div class="p-2 justify-content-end">
                    <button (click)="_confirm()" [attr.aria-expanded]="!isCollapsed" aria-controls="false"
                      class="btn btn-outline-danger btn-sm" type="button">
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group col-xg-4 col-lg-2 col-md-12 col-sm-12">
      </div>
      <div class="form-groupcol-xg-4 col-lg-2 col-md-12 col-sm-12">
        <button class="btn btn-usblick" type="submit"
          [disabled]="(!_form.valid || _findData || _form.value['arrivalDate'] === null || userService.itineraryActive.length == 0)"
          data-toggle="modal">
          <i class="{{_findData?'fa fa-spinner fa-spin fa-sm':''}}"></i>
          Start
        </button>
      </div>


    </div>
    <!-- <div class="d-flex form-row flex-row justify-content-start align-items-center py-3" id="selector">
      <label class="d-flex pb-2 form-group align-items-center" style="font-size: 0.8rem">Select any option</label>
      <div class="d-flex p-2 form-group align-items-center justify-content-end">
        <div class="radio d-flex p-0 align-items-center justify-content-between">
          <label class="d-flex align-items-center">
            <input formControlName="options" class="form-check-input" type="radio" name="options" id="options" value="OnlyHotel">
            <span class="cr">
              <i class="cr-icon fa fa-circle"></i>
            </span>
          </label>
        </div>
        <label class="px-4">Only hotel</label>
      </div>
      <div class="d-flex p-2 form-group align-items-center justify-content-end">
        <div class="radio d-flex p-0 align-items-center justify-content-between">
          <label class="d-flex align-items-center">
            <input formControlName="options" class="form-check-input" type="radio" name="options" id="options" value="HotelAndMealPlan">
            <span class="cr">
              <i class="cr-icon fa fa-circle"></i>
            </span>
          </label>
        </div>
        <label class="px-4">Hotel & meal plan</label>
      </div>
      <div class="d-flex p-2 form-group align-items-center justify-content-end">
        <div class="radio d-flex p-0 align-items-center justify-content-between">
          <label class="d-flex align-items-center">
            <input formControlName="options" class="form-check-input" type="radio" name="options" id="options" value="HotelAndTickets">
            <span class="cr">
              <i class="cr-icon fa fa-circle"></i>
            </span>
          </label>
        </div>
        <label class="px-4">Hotel & Tickets</label>
      </div>
      <div class="d-flex p-2 form-group align-items-center justify-content-end">
        <div class="radio d-flex p-0 align-items-center justify-content-between">
          <label class="d-flex align-items-center">
            <input formControlName="options" class="form-check-input" type="radio" name="options" id="options" value="HotelAndTicketAndMealPlan">
            <span class="cr">
              <i class="cr-icon fa fa-circle"></i>
            </span>
          </label>
        </div>
        <label class="px-4" >Hotel+Tickets & meal plan</label>
      </div>
    </div> -->
  </form>
</div>